import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";

import { useAppStore } from "../../providers/AppStoreProvider";
import { useAPI } from "../../providers/ApiProvider";
import { SupportBanner } from "../SupportBanner/SupportBanner";
import { toastWithAsyncFetch } from "../../utils/helper";

export const ReportModal = observer(() => {
  const store = useAppStore();
  const api = useAPI();
  const contentRef = useRef();

  const reportValidate = (content) => {
    if (content?.length < 1) return false;
    return true;
  };

  const reportSubmitHandler = () => {
    reportValidate(contentRef.current.value) &&
      toastWithAsyncFetch(
        {
          loading: "Đang gửi báo lỗi lên hệ thống...",
          success: "Báo lỗi thành công.\nCảm ơn bạn đã báo cho ColorME!",
          error: "Báo lỗi thất bại!",
        },
        async () => {
          store.reportModal.setSubmitState(true);
          const res = await api.callApi("createErrorReport", {
            body: {
              type: "lesson",
              content_report: contentRef.current.value,
              table_id: store.currentLesson.id,
            },
          });
          store.reportModal.setSubmitState(false);

          return res;
        },
      );
  };

  return (
    <Modal size="lg" show={store.reportModal.show} onHide={store.reportModal.toggle}>
      <Modal.Header closeButton className="border-0">
        <Modal.Title as="h3" className="fw-bold">
          Báo lỗi
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label className="fw-bold">Bài học</Form.Label>
            <Form.Control
              name="lesson_name"
              rows={4}
              placeholder="Tên bài học"
              className="rounded-10 mt-1 p-3 py-2"
              value={store.currentLesson?.name ?? ""}
              disabled
            />
          </Form.Group>

          <Form.Group className="my-4">
            <Form.Label className="fw-bold">Mô tả</Form.Label>
            <Form.Control
              as="textarea"
              name="review"
              rows={4}
              ref={contentRef}
              required
              placeholder="Ví dụ: Video không xem được"
              className="rounded-10 mt-1 p-3 py-2"
              disabled={store.reportModal.isSubmitting}
            />
          </Form.Group>
        </Form>

        <SupportBanner simple />
      </Modal.Body>

      <Modal.Footer className="border-0">
        <Button
          variant="outline"
          className="text-black-50 rounded-pill border-0 p-2 px-4"
          onClick={store.reportModal.toggle}
          disabled={store.reportModal.isSubmitting}
        >
          Hủy
        </Button>
        <Button
          className="fw-bold rounded-pill bg-gradient-orange border-0 p-2 px-4"
          onClick={reportSubmitHandler}
          disabled={store.reportModal.isSubmitting}
        >
          {store.reportModal.isSubmitting ? (
            <span>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Đang gửi
            </span>
          ) : (
            <span>Hoàn tất</span>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
});
